/**
 * The initial values for the redux state.
 */
export default {
  itemOptions: [],
  itemIsLoading: false,

  settingIsLoading: false,
  settings: {
    cron: '',
    item_ids_select2: []
  }
};
